import { queryOptions } from '@tanstack/react-query'
import { getLandingV2DataAction } from '@/actions/landing/get-main-landing-data-action'
import { FoodParamType } from '@/constants/food-type'
import { getFoodHallDataAction } from '@/actions/landing/get-food-hall-data-action'

export const landingQuery = {
  v2Data: queryOptions({
    queryKey: ['landing-data-v2'],
    queryFn: async () => {
      const response = await getLandingV2DataAction()
      if (response.type === 'error') {
        throw new Error('Failed to fetch landing v2 data', {
          cause: response.error,
        })
      }
      const { data } = response
      const { brandHall, drinkHall, snackHall } = data.todayLowestSection

      return {
        ...data,
        todayLowestSection: shuffleArray([
          ...getTwoRandomItems(brandHall.products),
          ...getTwoRandomItems(drinkHall.products),
          ...getTwoRandomItems(snackHall.products),
        ]),
      }
    },
  }),
  foodHall: (type: FoodParamType) =>
    queryOptions({
      queryKey: ['foodHallData', type],
      queryFn: async () => {
        const response = await getFoodHallDataAction({ type })
        if (response.type === 'error') {
          throw new Error(`Failed to fetch ${type}-hall data`, {
            cause: response.error,
          })
        }
        return response.data
      },
    }),
}

function getTwoRandomItems<T>(list: T[]): [T, T] | T[] {
  if (list.length < 2) return list

  const firstIndex = Math.floor(Math.random() * list.length)
  let secondIndex: number

  do {
    secondIndex = Math.floor(Math.random() * list.length)
  } while (secondIndex === firstIndex)

  return [list[firstIndex], list[secondIndex]]
}

function shuffleArray<T>(array: T[]): T[] {
  const result = [...array] // 원본 배열을 복사
  if (result.length === 0) return result
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]] // swap
  }
  return result
}
